module.exports = __webpack_public_path__ + "static/media/Disclaimer.dc293fa1.pdf";